<template>
  <div class="registration-closed">
    <b-notification>
      Registration for this event is currently closed.
    </b-notification>
  </div>
</template>

<script>
  export default {
    name: 'Profile',
    data: function () {
      return {
      }
    },
    props: {
    },
    methods: {
    },
  }
</script>

<style lang="scss" scoped>
</style>
